import { createSlice } from "@reduxjs/toolkit";

// Get initial state from localStorage if available
const getInitialState = () => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');
    const storedOriginalAdmin = localStorage.getItem('originalAdminUser');
    
    return {
        currentUser: storedUser ? JSON.parse(storedUser) : null,
        loading: false,
        token: storedToken,
        error: false,
        profile_photo_path: null,
        originalAdminUser: storedOriginalAdmin ? JSON.parse(storedOriginalAdmin) : null
    };
};

export const userSlice = createSlice({
    name: "user",
    initialState: getInitialState(),
    reducers: {
        loginStart: (state) => {
            state.loading = true;
            state.error = false;
        },
        loginSuccess: (state, action) => {
            state.loading = false;
            // Ensure has_auctions is included in the user data
            state.currentUser = {
                ...action.payload.user,
                has_auctions: action.payload.user.has_auctions || false
            };
            state.token = action.payload.token;
            state.error = false;
            
            // Persist to localStorage
            localStorage.setItem('user', JSON.stringify(state.currentUser));
            localStorage.setItem('token', action.payload.token);
        },
        loginFailure: (state) => {
            state.loading = false;
            state.error = true;
        },
        logout: (state) => {
            state.currentUser = null;
            state.token = null;
            state.loading = false;
            state.error = false;
            state.originalAdminUser = null;
            
            // Clear localStorage
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('originalAdminUser');
        },
        updateAvatar: (state, action) => {
            state.currentUser.profile_photo_path = action.payload;
            // Update localStorage
            localStorage.setItem('user', JSON.stringify(state.currentUser));
        },
        setOriginalAdminUser: (state, action) => {
            state.originalAdminUser = action.payload;
            localStorage.setItem('originalAdminUser', JSON.stringify(action.payload));
        },
        clearOriginalAdminUser: (state) => {
            state.originalAdminUser = null;
            localStorage.removeItem('originalAdminUser');
        },
        updateUserProfile: (state, action) => {
            state.currentUser = { ...state.currentUser, ...action.payload };
            // Update localStorage
            localStorage.setItem('user', JSON.stringify(state.currentUser));
        },
        updateAuctionStatus: (state, action) => {
            state.currentUser.has_auctions = action.payload;
            // Update localStorage
            localStorage.setItem('user', JSON.stringify(state.currentUser));
        },
        toggleFavoriteAuction: (state, action) => {
            const auctionId = action.payload;
            if (!state.currentUser.favorite_auctions) {
                state.currentUser.favorite_auctions = [];
            }
            
            const index = state.currentUser.favorite_auctions.indexOf(auctionId);
            if (index === -1) {
                state.currentUser.favorite_auctions.push(auctionId);
            } else {
                state.currentUser.favorite_auctions.splice(index, 1);
            }
            
            // Update localStorage
            localStorage.setItem('user', JSON.stringify(state.currentUser));
        },
        toggleFavoriteLot: (state, action) => {
            const lotId = action.payload;
            if (!state.currentUser.favorite_lots) {
                state.currentUser.favorite_lots = [];
            }
            
            const index = state.currentUser.favorite_lots.indexOf(lotId);
            if (index === -1) {
                state.currentUser.favorite_lots.push(lotId);
            } else {
                state.currentUser.favorite_lots.splice(index, 1);
            }
            
            // Update localStorage
            localStorage.setItem('user', JSON.stringify(state.currentUser));
        },
        updateFavorites: (state, action) => {
            state.currentUser.favorite_auctions = action.payload.favorite_auctions || [];
            state.currentUser.favorite_lots = action.payload.favorite_lots || [];
            // Update localStorage
            localStorage.setItem('user', JSON.stringify(state.currentUser));
        }
    },
});

export const { 
    loginStart, 
    loginSuccess, 
    loginFailure, 
    logout, 
    updateAvatar,
    setOriginalAdminUser,
    clearOriginalAdminUser,
    updateUserProfile,
    updateAuctionStatus,
    toggleFavoriteAuction,
    toggleFavoriteLot,
    updateFavorites
} = userSlice.actions;

export default userSlice.reducer;
